import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import i18n from './i18n'
import dayjs from 'dayjs'

// Import all dayjs locales for supported languages
import 'dayjs/locale/it'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/pt'

library.add(faChevronRight, faChevronLeft)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Sync dayjs locale with i18n locale (already set in i18n.ts)
dayjs.locale(i18n.locale)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App)
}).$mount('#app')
